import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';

export default function Contact() {
  useReveal();
  const [form, setForm] = useState({ 
    name: '', 
    email: '', 
    mobile: '', 
    company: '', 
    enquiry: '', 
    context: '' 
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      // Replace this URL with your Google Apps Script Web App URL
      const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbxU3AJId2F3UEKaNjlXgKY102TcKKMddQopZ_hnLsM7XDQYJWOWB-MnpE_bu8hkGMTA/exec';
      
      const response = await fetch(GOOGLE_SHEETS_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form)
      });

      // With no-cors mode, we can't read the response
      // So we assume success if no error is thrown
      setSubmitted(true);
      setForm({ 
        name: '', 
        email: '', 
        mobile: '', 
        company: '', 
        enquiry: '', 
        context: '' 
      });
      
      setTimeout(() => setSubmitted(false), 5000);
      
    } catch (err) {
      console.error('Submission error:', err);
      setError('Failed to submit. Please try again or contact us directly.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="contact-section">
        {/* LEFT COLUMN */}
        <div className="contact-left">
          <div>
            <span className="sec-tag reveal">Get in Touch</span>
            <h2 className="reveal reveal-delay-1">
              A private<br />conversation.<br /><em>No obligation.</em>
            </h2>
            <p className="reveal reveal-delay-2">
              We engage with a limited number of new relationships each quarter. 
              If you believe there is a basis for discussion — around capital, growth, 
              or strategy — we invite you to reach out.
            </p>
          </div>
          <div className="contact-details reveal reveal-delay-2">
            <div className="cd-item">
              <div className="cd-label">Phone / WhatsApp</div>
              <div className="cd-value">
                <a 
                  href="https://api.whatsapp.com/send?phone=919667773258" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  +91 96677 73258
                </a>
              </div>
            </div>
            <div className="cd-item">
              <div className="cd-label">Legal &amp; Policy</div>
              <div className="cd-value">
                <a href="mailto:info@aqtdirect.com">info@aqtdirect.com</a>
              </div>
            </div>
            <div className="cd-item">
              <div className="cd-label">Mumbai Office</div>
              <div className="cd-value">
                311, Sector 19, NMS Icon<br />
                Navi Mumbai, Ulwe, Panvel<br />
                Maharashtra – 410206, India
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT COLUMN - FORM */}
        <div className="contact-right">
          <h3 className="reveal">Request a Private Discussion</h3>
          <p className="reveal reveal-delay-1">
            All enquiries are treated with complete confidentiality. 
            We do not share, publish, or discuss client enquiries.
          </p>

          {/* Success Message */}
          {submitted && (
            <div style={{
              background: 'rgba(29,184,138,0.1)',
              border: '1px solid rgba(29,184,138,0.3)',
              borderLeft: '3px solid #1DB88A',
              padding: '14px 20px',
              borderRadius: 4,
              marginBottom: 24,
              fontSize: 14,
              color: '#0F2D6B'
            }}>
              Thank you. We will be in touch within 24 hours.
            </div>
          )}

          {/* Error Message */}
          {error && (
            <div style={{
              background: 'rgba(220, 53, 69, 0.1)',
              border: '1px solid rgba(220, 53, 69, 0.3)',
              borderLeft: '3px solid #DC3545',
              padding: '14px 20px',
              borderRadius: 4,
              marginBottom: 24,
              fontSize: 14,
              color: '#DC3545'
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {/* Name Field */}
            <div className="cf-field reveal reveal-delay-1">
              <label className="cf-label">Your name</label>
              <input 
                className="cf-input" 
                type="text" 
                name="name" 
                placeholder="Full name" 
                value={form.name} 
                onChange={handleChange} 
                required 
              />
            </div>

            {/* Email & Mobile - Two Column */}
            <div className="cf-2col reveal reveal-delay-2">
              <div className="cf-field">
                <label className="cf-label">Email</label>
                <input 
                  className="cf-input" 
                  type="email" 
                  name="email" 
                  placeholder="Email address" 
                  value={form.email} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              <div className="cf-field">
                <label className="cf-label">Mobile</label>
                <input
                  className="cf-input"
                  type="tel"
                  name="mobile"
                  placeholder="+91"
                  value={form.mobile}
                  onChange={e => setForm(f => ({ ...f, mobile: e.target.value.replace(/[^0-9+\s\-()]/g, '') }))}
                  inputMode="numeric"
                />
              </div>
            </div>

            {/* Company Field */}
            <div className="cf-field reveal reveal-delay-2">
              <label className="cf-label">Company / Organisation</label>
              <input 
                className="cf-input" 
                type="text" 
                name="company" 
                placeholder="Company name" 
                value={form.company} 
                onChange={handleChange} 
              />
            </div>

            {/* Enquiry Type */}
            <div className="cf-field reveal reveal-delay-2">
              <label className="cf-label">Nature of enquiry</label>
              <select 
                className="cf-select" 
                name="enquiry" 
                value={form.enquiry} 
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option>Capital advisory &amp; investor introductions</option>
                <option>AQT Financial Officer engagement</option>
                <option>Expansion strategy advisory</option>
                <option>Investor registration</option>
                <option>Partner network enquiry</option>
                <option>General advisory discussion</option>
              </select>
            </div>

            {/* Context Textarea */}
            <div className="cf-field reveal reveal-delay-3">
              <label className="cf-label">Brief context</label>
              <textarea 
                className="cf-textarea" 
                name="context" 
                placeholder="A brief note on your business and what you are looking to discuss. No detail is required at this stage." 
                value={form.context} 
                onChange={handleChange} 
              />
            </div>

            {/* Submit Button */}
            <button 
              type="submit" 
              className="btn-primary reveal reveal-delay-3" 
              style={{ 
                width: '100%', 
                padding: 16, 
                borderRadius: 6, 
                textAlign: 'center',
                opacity: loading ? 0.7 : 1,
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Submit Request'}
            </button>
          </form>

          {/* Privacy Note */}
          <p className="contact-note reveal reveal-delay-4">
            By submitting, you confirm you have read our{' '}
            <Link to="/legal">Privacy Policy and Terms</Link>. 
            We respond to all enquiries within 24 hours.
          </p>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}